import { SyntheticEvent } from 'react';
import { Slider, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DifficultyLevelEnum } from '@protos/content_management/content.db_pb';

interface SliderLevel {
  key: DifficultyLevelEnum;
  value: number;
  label?: string;
}

interface IProps {
  sliderLevels: SliderLevel[];
  minLevel: number;
  maxLevel: number;
  step: number;
  slideValue: SliderLevel;
  titleText?: string;
  isDisable?: boolean;
  SliderOnChangeValue: (value: SliderLevel) => void;
  onChangeCommitted?: (
    event: Event | SyntheticEvent<Element, Event>,
    value: number | number[]
  ) => void;
}

// Styled MUI Slider
const SlideElement = styled(Slider)(({ theme }) => ({
  height: 10,
  padding: '30px 0',
  '& .MuiSlider-track': {
    background: 'none',
    border: 'none',
  },
  '& .MuiSlider-rail': {
    background: 'linear-gradient(to right, green, yellow, red)',
    opacity: 1,
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: 'yellow',
    border: '4px solid white',
    boxShadow: '0 0 0 4px rgba(0,0,0,0.1)',
    marginTop: 0,
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: '0 0 0 6px rgba(0,0,0,0.15)',
    },
  },
  '& .MuiSlider-mark': {
    backgroundColor: '#000',
    height: 12,
    width: 2,
    marginTop: 11,
  },
  '& .MuiSlider-mark[data-index="0"]': {
    marginLeft: '10px',
  },

  '& .MuiSlider-markLabel': {
    marginTop: 25,
    fontSize: 15,
    color: '#000',
  },
  '& .MuiSlider-markLabel[data-index="0"]': {
    marginLeft: '12px',
  },
  '& .MuiSlider-markLabel[data-index="4"]': {
    paddingRight: '20px',
  },
}));

export const Slide = (props: IProps) => {
  const {
    sliderLevels,
    titleText = 'Overall Difficulty',
    isDisable = false,
    minLevel,
    maxLevel,
    slideValue,
    step,
    SliderOnChangeValue,
    onChangeCommitted,
  } = props;

  return (
    <Box>
      <Typography variant="h3" fontWeight="bold">
        {titleText}
      </Typography>
      <SlideElement
        value={slideValue.value}
        marks={sliderLevels}
        min={minLevel}
        max={maxLevel}
        step={step}
        onChange={(event, newValue) => {
          const val = newValue as number;
          const selectedLevel = sliderLevels.find(
            (level) => level.value === val
          );
          if (selectedLevel) {
            SliderOnChangeValue(selectedLevel);
          }
        }}
        aria-label={titleText}
        disabled={isDisable}
        onChangeCommitted={onChangeCommitted}
        sx={{
          ...(slideValue.value === maxLevel && {
            '& .MuiSlider-thumb': {
              marginLeft: '-10px',
            },
          }),
          ...(slideValue.value === minLevel && {
            '& .MuiSlider-thumb': {
              marginLeft: '10px',
            },
          }),
          [`& .MuiSlider-mark[data-index="${sliderLevels.length - 1}"]`]: {
            marginLeft: '-10px',
          },
          [`& .MuiSlider-markLabel[data-index="${sliderLevels.length - 1}"]`]: {
            paddingRight: '20px',
          },
        }}
      />
    </Box>
  );
};
